import styles from "../styles/jobAdvertSection.module.scss";

export default function JobAdvertSection({ title, content }) {

    if (!content || content.trim() === "") {
        return null;
    }

    return (

        <div className={styles.section}>

            <h2>{title}</h2>

            <p>{content}</p>

        </div>

    );

}